import { render, staticRenderFns } from "./ReportTypeSelector.vue?vue&type=template&id=1560c0f3&scoped=true"
import script from "./ReportTypeSelector.vue?vue&type=script&lang=ts"
export * from "./ReportTypeSelector.vue?vue&type=script&lang=ts"
import style0 from "./ReportTypeSelector.vue?vue&type=style&index=0&id=1560c0f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1560c0f3",
  null
  
)

export default component.exports